import React, {Component} from 'react';
import BillingForm from "./BillingForm";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import Modal from "../../../components/material-pro/Modal/Modal";
import {Translate} from "react-redux-i18n";
import {toggleCreditDetails} from "../BillingActions";

class CreditDetailsModal extends Component {

    render() {
        const {billing: {saving, customer, openCreditDetails}, toggleCreditDetails} = this.props;
        return (
            <Modal
                open={openCreditDetails}
                disableBackdropClick={saving}
                onClose={() => toggleCreditDetails()}
                title={customer.last4Digits ?
                    <Translate value="billing.creditDetailsModal.headers.edit" last4Digits={customer.last4Digits}/> :
                    <Translate value="billing.creditDetailsModal.headers.add"/>
                }
                content={<BillingForm/>}
            />
        );
    }
}

const mapStateToProps = ({billing}) => ({billing});

const mapDispatchToProps = dispatch => bindActionCreators({toggleCreditDetails}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CreditDetailsModal);



// WEBPACK FOOTER //
// ./src/containers/billing/components/CreditDetailsModal.js